import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FooterModalComponent } from './footer-modal/footer-modal.component';
import { environment } from '../../environments/environment';
import { config } from '../config/config';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public version: string = environment.version;
  public md: any = '';
  public backend_md: any = '';
  public backend_ver:any = '0.0.0.0';
  show: boolean = false;
  constructor(private modalService: NgbModal) { }


  ngOnInit(): void {
    this.getData();
  }

  getData() {
    fetch(config['rootUrl'] + "assets/CHANGELOG.md")
      .then(response => {
        return response.text()
      })
      .then(data => {
        this.md = data;
      });
    fetch(config['rootUrl'] + "version/CHANGELOG.md")
      .then(response => {
        return response.text()
      })
      .then(data => {
        this.backend_md = data;
      });
    fetch(config['rootUrl'] + "version/version.json")
      .then(response => {
        return response.text()
      })
      .then(data => {
        const d = JSON.parse(data);
        this.backend_ver = d.version;
      });
  }

  showChangelog(f:boolean) {
    const modalRef = this.modalService.open(FooterModalComponent, {
      backdrop: 'static',
      size: 'lg',
    });
    if (f) {
      modalRef.componentInstance.md = this.md;
    } else {
      modalRef.componentInstance.md = this.backend_md;
    }

    modalRef.result.then(() => {
    });

  }
}
